export const SET_INDICATOR = "INDICATORS/SET_INDICATOR";
export const SET_INDICATORS = "INDICATORS/SET_INDICATORS";
export const SET_PAGINATION = "INDICATORS/SET_PAGINATION";
